import AdminApi from '../stylemix-vue-admin/plugins/api'

export default class CompanyPricesApi extends AdminApi {
  constructor(parameters) {
    super('company', parameters)
  }

  getTransferPricingForm(data) {
    this.setParameters(data)
    return this.submit('get', 'company/airport-pricing/form')
  }

  getTransferPricingIndex(data) {
    this.setParameters(data)
    return this.submit('get', 'company/airport-pricing/index')
  }

  getTransferPricing(data) {
    this.setParameters(data)
    return this.submit('get', 'company/airport-pricing')
  }

  updateTransferPricing(data) {
    return this.submit('post', 'company/airport-pricing', data)
  }

  getCityTaxiPricingForm(data) {
    this.setParameters(data)
    return this.submit('get', 'company/city-taxi-pricing/form', data)
  }

  getCityTaxiPricingIndex(data) {
    this.setParameters(data)
    return this.submit('get', 'company/city-taxi-pricing/index')
  }

  getCityTaxiPricing(data) {
    this.setParameters(data)
    return this.submit('get', 'company/city-taxi-pricing')
  }

  updateCityTaxiPricing(data) {
    return this.submit('post', 'company/city-taxi-pricing', data)
  }

  getCompanies() {
    return this.submit('get', 'company/city-taxi-pricing/companies')
  }

  getCompanyRelations(companyId, data) {
    this.setParameters(data)
    return this.submit('get', `companies/${companyId}/relations`)
  }

  getVehicles(data) {
    this.setParameters(data)
    return this.submit(
      'get',
      data?.where?.company_id
        ? `companies/${data.where.company_id}/vehicles`
        : 'company/vehicles'
    )
  }

  getAirports(data) {
    this.setParameters(data)
    return this.submit(
      'get',
      data?.where?.company_id
        ? `companies/${data.where.company_id}/airports`
        : 'company/airports'
    )
  }

  getDivisions(data) {
    this.setParameters(data)
    return this.submit(
      'get',
      data?.where?.company_id
        ? `companies/${data.where.company_id}/divisions`
        : 'company/divisions'
    )
  }
}
